import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import "../../../style/resource/projectCompletionReport.css";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const ProjectCompletionReport = () => {
  useEffect(() => {
    document.title = `Development Concern | Project Completion Report`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/project-completion-report";

  return (
    <div>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="project_completion_report_section">
        <div className="header_image">
          <p>Home | Resources</p>
          <h2>Project Completion Report</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2>Project Completion Report</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="content_wrapper">
          <div className="container">
            <h1>Project Completion Report</h1>
            <div className="report">
              <h5>
                Project Completion Report (January 2024 - December 2024)
              </h5>
              <a
                href="/"
                target={"_blank"}
                id="style-2"
                data-replace="Download Pdf"
              >
                <span> Download Pdf</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProjectCompletionReport;
